module.exports = __webpack_public_path__ + "img/wodekaoqing.0877dce4.png";